import { Box, Typography } from "@mui/material";
import { FC, useState } from "react";
import { Dialog, HypeIcon } from "..";
import { HInfo } from "../HInfo/HInfo";

export type THintSuffix = {
  openModalText?: string;
  openModalTextColor?: THypeColors;
  modalBody?: string;
  modalBodySuffix?: string;
  modalTitle?: string;
  openModalIconName?: HypeIconName;
  openModalIconColor?: THypeColors;
  openModalIconSize?: number;
};

export const HintSuffix: FC<THintSuffix> = ({
  modalBody,
  modalBodySuffix,
  modalTitle,
  openModalText,
  openModalIconName,
  openModalIconColor = "primary.main",
  openModalIconSize,
  openModalTextColor = "typography.link",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Box
        onClick={() => setIsOpen(true)}
        style={{ cursor: "pointer" }}
        display="flex"
        gap={2}
        alignItems="center"
      >
        {openModalText && (
          <Typography
            sx={theme => ({
              color: openModalTextColor || theme.palette.typography.link,
            })}
            variant="body"
            dangerouslySetInnerHTML={{ __html: openModalText }}
          />
        )}
        {openModalIconName && (
          <HypeIcon
            name={openModalIconName}
            color={openModalIconColor}
            size={openModalIconSize}
          />
        )}
        {!openModalIconName && !openModalText && (
          <HInfo size={openModalIconSize} />
        )}
      </Box>
      <Dialog
        isOpen={isOpen}
        title={modalTitle}
        text={modalBody}
        textSuffix={modalBodySuffix}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
